// extracted by mini-css-extract-plugin
export default {"root":"global-loading_root__t6S4D","mask":"global-loading_mask__UDRoQ"};